"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ListItem: true
};
exports.default = exports.ListItem = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _ListContext = require("./_ListContext");
var _ListItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ListItem.css") : void 0);
var _ListItem2 = require("./_ListItem.types");
Object.keys(_ListItem2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItem2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItem2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-list-item';
const ListItem = exports.ListItem = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      children,
      className,
      divider,
      isGroupHeader
    } = props,
    otherProps = __rest(props, ["children", "className", "divider", "isGroupHeader"]);
  const classnames = _bind.default.bind(_ListItem.default);
  const listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  const {
    bordered,
    transparent
  } = listContextValue || {};
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--grouped`]: isGroupHeader,
    [`${CSS_BLOCK}--bordered`]: bordered,
    [`${CSS_BLOCK}--transparent`]: transparent
  });
  if (divider) {
    return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, otherProps, {
      className: classnames(className, CSS_BLOCK, `${CSS_BLOCK}__divider`),
      ref: ref,
      role: "separator",
      "aria-hidden": true
    }));
  }
  return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, otherProps, {
    className: classes,
    ref: ref
  }), children);
});
ListItem.displayName = 'List.Item';
var _default = exports.default = ListItem;